/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/* @relayHash 0db31a6fc11276583a9866c779b3063c */

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type GuildsScreenAllQueryVariables = {};
export type GuildsScreenAllQueryResponse = {
    readonly " $fragmentRefs": FragmentRefs<"GuildsScreenAllList_query">;
};
export type GuildsScreenAllQuery = {
    readonly response: GuildsScreenAllQueryResponse;
    readonly variables: GuildsScreenAllQueryVariables;
};



/*
query GuildsScreenAllQuery {
  ...GuildsScreenAllList_query
}

fragment GuildCardNew_guild on Guild {
  rowId
  slugId
  name
  description
  type
  myMembership {
    membershipLevel
    id
  }
  networkMembers {
    totalCount
  }
  ...GuildPrimaryPhotoNew_guild
  backgroundPhoto {
    rowId
    contentType
    id
  }
}

fragment GuildList_guildsConnection on GuildsConnection {
  edges {
    node {
      ...GuildCardNew_guild
      id
    }
    cursor
  }
}

fragment GuildPrimaryPhotoNew_guild on Guild {
  name
  rowId
  primaryPhoto {
    rowId
    contentType
    id
  }
}

fragment GuildsScreenAllList_query on Query {
  guilds: rankedGuilds(first: 12) {
    ...GuildList_guildsConnection
    edges {
      cursor
      node {
        __typename
        id
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 12
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = [
  (v1/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "contentType",
    "storageKey": null
  },
  (v2/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "GuildsScreenAllQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "GuildsScreenAllList_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "GuildsScreenAllQuery",
    "selections": [
      {
        "alias": "guilds",
        "args": (v0/*: any*/),
        "concreteType": "GuildsConnection",
        "kind": "LinkedField",
        "name": "rankedGuilds",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "GuildsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Guild",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "slugId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "description",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "type",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "GuildMembership",
                    "kind": "LinkedField",
                    "name": "myMembership",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "membershipLevel",
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UsersConnection",
                    "kind": "LinkedField",
                    "name": "networkMembers",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "totalCount",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Image",
                    "kind": "LinkedField",
                    "name": "primaryPhoto",
                    "plural": false,
                    "selections": (v3/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Image",
                    "kind": "LinkedField",
                    "name": "backgroundPhoto",
                    "plural": false,
                    "selections": (v3/*: any*/),
                    "storageKey": null
                  },
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "rankedGuilds(first:12)"
      },
      {
        "alias": "guilds",
        "args": (v0/*: any*/),
        "filters": null,
        "handle": "connection",
        "key": "GuildsScreenAllList_query_guilds",
        "kind": "LinkedHandle",
        "name": "rankedGuilds"
      }
    ]
  },
  "params": {
    "id": "329ebecd14c4a4ef2bcd55804980df9ab7c1b2ec98ef158fc484d0fdcd6ccbe5",
    "metadata": {},
    "name": "GuildsScreenAllQuery",
    "operationKind": "query",
    "text": null
  }
};
})();
(node as any).hash = '072e310c39968bca049601aa06f6db59';
export default node;
